'use client';

import { useEffect, useState } from 'react';

import { hasDesktopBridge } from '../lib/desktopBridge';

/**
 * 데스크탑 앱(webview, `window.agentteamsBridge` 주입) 안에서 실행 중인지 여부.
 *
 * 브리지는 preload에서 페이지 스크립트보다 먼저 주입되므로 마운트 시 1회 확인으로 충분하다.
 * SSR/일반 브라우저에서는 false.
 */
export const useIsDesktopApp = (): boolean => {
  const [isDesktopApp, setIsDesktopApp] = useState(false);
  useEffect(() => {
    setIsDesktopApp(hasDesktopBridge());
  }, []);
  return isDesktopApp;
};
